// extracted by mini-css-extract-plugin
export default {"chipContainer":"betChips_chipContainer__XSpPO","chip":"betChips_chip__HsGYY"};